import 'url-search-params-polyfill';

export class Utils {
    /**
     * Gets the value from a query param
     *
     * @param param
     * @param defaultValue
     *
     * @returns {string}
     */
    public static getValueFromQueryParam(param: string, defaultValue: string = ''): string {
        let value;

        param = param.trim();
        defaultValue = defaultValue.trim();

        try {
            value = new URLSearchParams(window.location.search).get(param);
        } catch (e) {}

        return (value || defaultValue).trim();
    }

    /**
     * Checks if the current browser is IE
     *
     * @returns {boolean}
     */
    public static isIe(): boolean {
        //@ts-ignore
        return !!window.MSInputMethodContext && !!document.documentMode;
    }

    /**
     * Checks if a toggle is true (Boolean) or "true" (String)
     *
     * @returns {boolean}
     */
    public static isToggleOn = (toggle) => {
        return toggle && toggle !== 'false';
    };

}
